import React from 'react'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useGetCompaniesCountByIndustryQuery } from '../../redux/slices/visualisationSlice';
import Loader from '../Loader';
import ErrorAlert from '../ErrorAlert';


ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)


const CompaniesByIndustry = () => {


    const { data: companyIndustries, isLoading: isLoadingCompanyIndustries, isSuccess: isSuccessCompanyIndustries, isError: isErrorCompanyIndustries, error: errorCompanyIndustries } = useGetCompaniesCountByIndustryQuery(undefined, {
        refetchOnMountOrArgChange: true,
    })

    let content;


    if (isLoadingCompanyIndustries) {
        content = (
            <Loader />
        )
    } else if (isSuccessCompanyIndustries && companyIndustries) {

        const options = {
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: true,
                    text: 'Companies by Industry (Top 20)',
                },
            },
        };

        // console.log('companies', companyIndustries)

        // console.log('companiesSorted', companyIndustries.sort((a, b) => b?.companies - a?.companies))
        // const indusLabels = companyIndustries.filter(indust => indust.isSub === false).map(({ industry }) => industry)

        // const indusData = companyIndustries.filter(indust => indust.isSub === false).map(({ companies }) => companies)

        // const indusLabels50 = indusLabels.slice(0, 20)

        // const indusData50 = indusData.slice(0, 20)

        // const labels = [...new Set(indusLabels50)];

        const companyIndus20 = companyIndustries.slice(0, 20);

        const data = {
            labels: companyIndus20.map((d) => { return d.industry }),
            datasets: [
                {
                    label: '',
                    data: companyIndus20.map((d) => { return d.companies }),
                    backgroundColor: '#ffc700',
                },
            ],
        };



        content = (
            <Bar options={options} data={data} />
        )
    } else if (isErrorCompanyIndustries) {
        content = (
            <ErrorAlert title="Error Loading Company Industry Stats!" error={JSON.stringify(errorCompanyIndustries, null, 2)} />
        )
    } else {
        content = (
            <Loader />
        )
    }

    return content;
}

export default CompaniesByIndustry
